const triggerPostToSaveBetaAccessRequest = async (username) => {
  try {
    const response = await fetch('https://api.gotcowjuice.com:2000/save-beta-access-request', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'cow-juice-api-key': process.env.REACT_APP_COWJUICE_API_KEY,
      },
      body: JSON.stringify({ username }),
    });

    const data = await response.json();

    if (response.status === 409) {
      return { success: false, reason: 'duplicate' };
    }

    if (!response.ok) {
      return { success: false, reason: 'unknown' };
    }

    localStorage.setItem('cowjuice_beta_request_username', username.trim().toLowerCase().replace(/^@/, '')); // For tracking across sessions.

    return { success: true };
  } catch (error) {
    console.error('❌ Error requesting beta access:', error);
    return { success: false, reason: 'network' };
  }
};

export default triggerPostToSaveBetaAccessRequest;
